import React from 'react';

export const getFieldLabel = (text, mandatory = true) => {
  return (
    <div>
      <span>{text}</span>
      {mandatory && <span className={'text-danger'}>*</span>}
    </div>
  )
};